import Home from "../page/Home/Home"
import {
  Routes,
  Route,
  useLocation,
  Navigate,
  BrowserRouter as Router,
} from "react-router-dom"
import Nav from "../component/nav/nav"
import BreadCrumb from "../component/breadcrumb/breadcrumb"
import Subjects from "../page/Subjects/Subjects"
import Questions from "../page/Questions/Questions"
import Templates from "../page/Templates/Templates"
import Exams from "../page/Exams/Exams"
import QuestionDetail from "../page/Questions/QuestionDetail"
import CreateQuestion from "../page/CreateQuestion/CreateQuestion"
import QuestionPreview from "../page/QuestionPreview/QuestionPreview"
import QuestionPreviewV2 from "../page/QuestionPreviewV2/QuestionPreviewV2"
import Teacher from "../page/Teacher/Teacher"
import CreateTeacher from "../page/Teacher/CreateTeacher"
import { UserLoginDetail } from "../component/nav/UserInterface"
import CreateSubject from "../page/Subjects/CreateSubject"
import SubjectDetail from "../page/Subjects/detail/SubjectDetail"
import SingleTemplate from "../page/Templates/TemplateDetails"
import CreateExam from "../page/Exams/CreateExam"
import SelectTopics from "../page/Exams/SelectTopics"
import SetQuestion from "../page/Exams/SetQuestion"
import ExamPaper from "../page/Exams/ExamPaper"
import CreateTemplate from "../page/Templates/Create/CreateTemplates"
import { TemplateDataProvider } from "../Context/TemplateData.context"
import UseTemplate from "src/page/UseTemplate/UseTemplate"

interface ProtectedRoutesProps {
  user: UserLoginDetail // Define the user prop
}

function ProtectedRoutes({ user }: ProtectedRoutesProps) {
  const { pathname } = useLocation()

  return (
    <>
      {pathname !== "/" && <BreadCrumb />}
      <Routes>
        <Route path='/' element={<Home />} />
        <Route
          path='/teachers'
          element={user && user.role === "admin" && <Teacher />}
        />
        <Route
          path='/teachers/create'
          element={user && user.role === "admin" && <CreateTeacher />}
        />
        <Route
          path='/subjects'
          element={user && user.role === "admin" && <Subjects />}
        />
        <Route
          path='/subjects/create'
          element={user && user.role === "admin" && <CreateSubject />}
        />
        <Route
          path='/subjects/:id'
          element={user && user.role === "admin" && <SubjectDetail />}
        />
        {/* <Route path="/subjects" element={<Subjects />} /> */}
        <Route path='/questions' element={<Questions />} />
        <Route
          path='/questions/view-question/:id'
          element={<QuestionDetail />}
        />
        <Route path='/questions/create-question' element={<CreateQuestion />} />
        <Route
          path='/questions/edit-question/:id'
          element={<CreateQuestion />}
        />
        <Route
          path='/questions/preview-question/:bulk_session_id'
          element={<QuestionPreviewV2 />}
        />
        <Route
          path='/questions/preview-question-old/:bulk_session_id'
          element={<QuestionPreview />}
        />
        <Route path='/templates' element={<Templates />} />
        <Route
          path='/templates/:templateId/details'
          element={<SingleTemplate />}
        />
        <Route
          path='/templates/create'
          element={
            <TemplateDataProvider>
              <CreateTemplate />
            </TemplateDataProvider>
          }
        />

        {/* <Route
          path="/templates/:templateId/details"
          element={
            <TemplateDataProvider>
              <CreateTemplate />
            </TemplateDataProvider>
          }
        /> */}

        <Route
          path='/templates/template/:templateId/edit'
          element={
            <TemplateDataProvider>
              <CreateTemplate />
            </TemplateDataProvider>
          }
        />
        <Route
          path='/exams/create-with-template'
          element={
            <TemplateDataProvider>
              <CreateTemplate />
            </TemplateDataProvider>
          }
        />

        <Route
          path='/templates/template-use/:templateId'
          element={<UseTemplate />}
        />
        <Route path='/edit/exam/:examId' element={<UseTemplate />} />
        <Route path='/exams' element={<Exams />} />
        <Route path='/exams/create-exam' element={<CreateExam />} />
        <Route
          path='/exams/create-exam/:subjectId'
          element={<SelectTopics />}
        />

        <Route
          path='/exams/create-exam/set-question'
          element={<SetQuestion />}
        />

        <Route path='/exams/create-exam/exam-paper' element={<ExamPaper />} />
      </Routes>
    </>
  )
}

export default ProtectedRoutes
